import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, ControlContainer, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-product-form',
  templateUrl: './product-form.component.html',
  styleUrls: ['./product-form.component.css']
})
export class ProductFormComponent implements OnDestroy, OnInit {

  @Input() editMode: boolean = true;
  @Input() appearance: 'standard' | 'fill' | 'outline' = 'fill';

  formGroup: FormGroup;

  private _subscriptions: Subscription[] = [];

  constructor(
    private _controlContainer: ControlContainer
  ) { }

  ngOnDestroy(): void {
    for (let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this.formGroup = this._controlContainer.control as FormGroup;
  }

  get productsetupcostControl(): AbstractControl {
    return this.formGroup.controls['productsetupcost'];
  }
  get productrentalcostControl(): AbstractControl {
    return this.formGroup.controls['productrentalcost'];
  }
  get productpurchasecostControl(): AbstractControl {
    return this.formGroup.controls['productpurchasecost'];
  }

}
